<template lang="pug">
  .news__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'NewsPreloader'
}
</script>
